// This file is auto-generated by @hey-api/openapi-ts

export const CardTypesEnum = {
    SMART_CARD: 'SMART_CARD',
    SMART_CARD_2: 'SMART_CARD_2',
    SMART_CARD_WITHOUT_STRUCTURE: 'SMART_CARD_WITHOUT_STRUCTURE',
    BANK_CARD: 'BANK_CARD',
    MOBILE_PHONE: 'MOBILE_PHONE',
    WHITE_LIST_CARD: 'WHITE_LIST_CARD',
    EXTERNAL_CARD: 'EXTERNAL_CARD',
    QR_CODE_CARD: 'QR_CODE_CARD',
    PAPER_CARD: 'PAPER_CARD',
    PID_CARD: 'PID_CARD',
    PILSEN_CARD: 'PILSEN_CARD'
} as const;

export type CardTypesEnum = typeof CardTypesEnum[keyof typeof CardTypesEnum];
